{
  "tabs": {
    "chat": "聊天",
    "reminders": "提醒",
    "calendar": "日历",
    "settings": "设置"
  },
  "common": {
    "cancel": "取消",
    "save": "保存",
    "confirm": "确认",
    "delete": "删除",
    "back": "返回",
    "close": "关闭",
    "edit": "编辑",
    "search": "搜索",
    "all": "全部",
    "loading": "加载中...",
    "error": "出错了",
    "notFound": "未找到",
    "tryAgain": "请重试",
    "retry": "重试",
    "undo": "撤销",
    "pullToRefresh": "下拉刷新",
    "justNow": "刚刚"
  },
  "auth": {
    "welcome": "欢迎使用 FishMemory",
    "tagline": "您的 WhatsApp 提醒助手，随身携带。",
    "subtitle": "您的 WhatsApp 提醒助手，随身携带。",
    "phoneLabel": "您的 WhatsApp 号码",
    "phoneHint": "我们将通过 WhatsApp 发送验证码",
    "invalidPhone": "请输入有效的电话号码",
    "continue": "继续",
    "enterPhone": "输入您的 WhatsApp 号码",
    "phonePlaceholder": "电话号码",
    "sendCode": "发送验证码",
    "verifyTitle": "验证您的号码",
    "otpSentTo": "6 位验证码已通过 WhatsApp 发送至 {{phone}}",
    "enterFullCode": "请输入全部 6 位数字",
    "invalidOtp": "验证码无效，请重试。",
    "otpFailed": "发送验证码失败，请重试。",
    "otpResent": "验证码已重新发送",
    "resendIn": "{{seconds}}秒后重发",
    "resendCode": "重新发送验证码",
    "enterOtp": "输入发送到您 WhatsApp 的验证码",
    "verify": "验证",
    "resend": "重新发送验证码",
    "wrongNumber": "号码错误？",
    "backToPhone": "返回输入号码",
    "editPhone": "编辑电话号码",
    "error": "错误",
    "setupTitle": "开始设置",
    "setupSubtitle": "您可以稍后在设置中更改",
    "namePlaceholder": "您的名字",
    "letsGo": "完成设置",
    "skipForNow": "暂时跳过"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "输入消息...",
    "inputPlaceholder": "输入消息...",
    "typing": "FishMemory 正在输入...",
    "online": "在线",
    "connecting": "连接中...",
    "reconnecting": "重新连接中...",
    "offline": "离线",
    "empty": "开始聊天",
    "emptyHint": "创建提醒，查看日程，或寻求帮助。",
    "emptyAction": "发送示例提醒",
    "actions": "聊天操作",
    "keep": "保留消息",
    "clearTitle": "清空聊天",
    "clearConfirm": "是否删除此设备上的所有消息？此操作不可撤销。",
    "clear": "清空聊天",
    "optionSelected": "已选择：{{label}}",
    "sendingSelection": "发送中...",
    "connectionLost": "重新连接中..."
  },
  "reminders": {
    "title": "我的提醒",
    "active": "进行中",
    "today": "今天",
    "thisWeek": "本周",
    "history": "历史",
    "items": "条",
    "emptyTitle": "暂无提醒",
    "emptySubtitle": "在聊天中创建提醒，便会显示在这里。",
    "emptyAction": "打开聊天",
    "filterActive": "进行中",
    "filterToday": "今天",
    "filterWeek": "本周",
    "filterHistory": "历史",
    "emptyState": "暂无提醒，开始聊天吧！",
    "swipeDone": "完成",
    "swipeSnooze": "稍后提醒",
    "swipeDelete": "删除",
    "search": "搜索提醒...",
    "upcoming": "即将到来",
    "completed": "已完成",
    "overdue": "逾期",
    "tomorrow": "明天",
    "synced": "已同步 {{value}}",
    "swipeHint": "滑动提醒查看更多操作",
    "noResults": "无匹配提醒",
    "noResultsHint": "试试其他关键词或清除搜索",
    "deleteAllFailed": "删除所有提醒失败"
  },
  "calendar": {
    "title": "日历",
    "today": "今天",
    "tomorrow": "明天",
    "completed": "已完成",
    "noEvents": "无日程",
    "noEventsSubtitle": "选择日期查看提醒和日历事件。",
    "googleEvent": "Google 日历",
    "legendActive": "进行中",
    "legendRecurring": "重复",
    "legendDone": "已完成",
    "legendGoogle": "Google",
    "previousMonth": "上月",
    "nextMonth": "下月",
    "previousYear": "去年",
    "nextYear": "明年",
    "goToToday": "回到今天",
    "all": "全部",
    "active": "进行中",
    "done": "已完成",
    "paused": "已暂停"
  },
  "settings": {
    "title": "设置",
    "profile": "个人资料",
    "name": "显示名称",
    "enterName": "输入您的名字",
    "language": "语言",
    "uiLanguage": "应用语言",
    "uiLanguageHelp": "仅更改此设备上的应用界面、日历标签和布局方向。",
    "serverLanguage": "聊天语言",
    "serverLanguageHelp": "更改服务器回复和提醒消息的语言。",
    "timezone": "时区",
    "currentTimezone": "当前时区",
    "timezoneHelp": "所有提醒时间均按此时区显示。",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "保存时区",
    "timezoneSaved": "时区已更新",
    "detect": "检测",
    "detectFailed": "无法检测时区",
    "autoDetect": "自动从 GPS 检测",
    "notifications": "通知",
    "notificationsHelp": "后续提醒控制提醒后的重复通知。设备通知权限在手机设置中管理。",
    "pushEnabled": "推送通知",
    "autoDoneOnFire": "提醒触发后自动标记完成",
    "autoDoneOnFireDesc": "关闭时，提醒保持进行中，直到您标记完成。",
    "googleCalendar": "Google 日历",
    "google": "Google 日历",
    "googleConnected": "已连接",
    "googleDisconnected": "未连接",
    "googleConnectedHelp": "新提醒可自动同步到您的日历。",
    "googleDisconnectedHelp": "连接 Google 日历以同步提醒和事件。",
    "googleConnectFailed": "连接 Google 日历失败",
    "connected": "已连接",
    "disconnected": "未连接",
    "connect": "连接",
    "disconnect": "断开连接",
    "autoSync": "自动同步新提醒",
    "autosync": "自动同步新提醒",
    "subscription": "订阅",
    "trialUsed": "试用：{{used}}/{{total}} 已用",
    "trialStatus": "可用试用",
    "activeStatus": "订阅有效",
    "expiredStatus": "订阅已过期",
    "unsubscribedStatus": "未订阅",
    "about": "关于",
    "version": "版本",
    "logout": "登出",
    "logoutTitle": "登出",
    "logoutConfirm": "确定要登出吗？",
    "noName": "未设置名称",
    "serverConnection": "服务器连接",
    "serverUrl": "服务器 URL",
    "serverEdit": "编辑",
    "saveReconnect": "保存并重新连接",
    "resetDefault": "恢复默认",
    "invalidServerUrlTitle": "无效的服务器 URL",
    "invalidServerUrlMessage": "请输入有效的 http 或 https 服务器 URL，例如 https://example.com",
    "uiLanguageChangeFailed": "更改应用语言失败，请重试。",
    "serverLanguageChangeFailed": "更改聊天语言失败，请重试。",
    "timezoneChangeFailed": "更改时区失败，请重试。",
    "autoSyncChangeFailed": "更新自动同步失败，请重试。",
    "nameChangeFailed": "更新显示名称失败，请重试。",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "提醒详情",
    "editTime": "编辑时间",
    "rename": "重命名",
    "snooze": "稍后提醒",
    "snooze15": "延迟 15 分钟",
    "pause": "暂停",
    "pauseReminder": "暂停提醒",
    "resume": "恢复",
    "resumeReminder": "恢复提醒",
    "skip": "跳过下次",
    "skipOccurrence": "跳过此次",
    "syncGoogle": "同步到 Google",
    "delete": "删除",
    "deleteTitle": "删除提醒",
    "deleteConfirm": "此提醒将被永久删除。",
    "deleteRecurringTitle": "删除重复提醒",
    "deleteRecurringMessage": "您想跳过此次还是删除整个系列？",
    "deleteThisOccurrence": "跳过此项",
    "deleteEntireSeries": "删除整个系列",
    "done": "完成",
    "markDone": "标记为完成",
    "undo": "恢复",
    "undoPrompt": "需要重新激活？立即恢复。",
    "recurring": "重复",
    "nextRun": "下次执行",
    "oneTime": "一次性",
    "pending": "待处理",
    "sent": "已发送",
    "paused": "已暂停",
    "active": "进行中",
    "snoozed": "已延迟",
    "localTime": "显示为本地时间",
    "recurrence": "重复规则",
    "created": "创建时间",
    "tags": "标签",
    "fireCount": "触发次数",
    "actions": "操作",
    "none": "无",
    "snoozeFailed": "延迟提醒失败",
    "pauseFailed": "暂停提醒失败",
    "resumeFailed": "恢复提醒失败",
    "skipFailed": "跳过提醒失败",
    "doneFailed": "标记完成失败",
    "undoFailed": "恢复状态失败",
    "deleteFailed": "删除提醒失败",
    "rescheduleTitle": "重新安排？",
    "rescheduleMsg": "此提醒已逾期，是否重新安排？",
    "reschedule15": "15 分钟后",
    "reschedule60": "1 小时后",
    "keepOverdue": "保持不变"
  },
  "onboarding": {
    "slide1Title": "欢迎使用 FishMemory",
    "slide1Sub": "您的个人提醒助手 — 由 WhatsApp 驱动，专为您设计。",
    "slide2Title": "自然聊天即可",
    "slide2Sub": "按您的习惯输入提醒：“提醒我明天下午3点给妈妈打电话” — 其余交给我们。",
    "slide3Title": "不错过任何事",
    "slide3Sub": "及时通知，标签管理，掌控重要事项。",
    "getStarted": "开始使用",
    "next": "下一步",
    "firstReminderTitle": "创建您的第一个提醒！",
    "firstReminderHint": "试试输入：",
    "firstReminderExample": "提醒我明天上午9点喝水",
    "gotIt": "明白了！",
    "notifRationaleTitle": "准时提醒",
    "notifRationaleBody": "FishMemory 需要通知权限以准时提醒您。仅对您创建的提醒发送通知。",
    "notifRationaleAllow": "启用通知",
    "notifRationaleLater": "稍后再说",
    "swipeHint": "右滑快速操作 →",
    "calendarDragHint": "拖动展开 ↕"
  }
}
